import {store} from "../../redux/store";
import {logOut} from 'vendors/redux/slices/authSlice';

export default () => {
    store.dispatch(logOut())
}
